import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import '../Styles/D_passport.css'
import axios from 'axios'
import { FileUploader } from "react-drag-drop-files";
export default function D_Passport() {
    const [bol, setBol] = useState(false)
    const [data, setData] = useState({
        passport_number: '',
        passport_file: ''
    })
    const getData = async () => {
        await axios.get(`${process.env.REACT_APP_API_URL1}/consultant/Passport_module/`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        })
            .then(response => {
                setData(response.data)
                response.data.passport_number === "" ? setBol(true) : console.log('allset')
            }).catch(err => {
                // let notify = document.getElementsByClassName('noti')[0];
                // notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                //         ${err.response.data.message}
                //     </div>`;
                // setTimeout(() => {
                //     notify.removeChild(notify.lastChild)
                // }, 3000);
                console.log(err)
            })
    }
    useEffect(async () => {
        await getData();
    }, [])
    const fileTypes = ["JPG","JPEG", "PNG", "PDF"];
    const [file, setFile] = useState(null);
    const handleChange = (file) => {
        setFile(file);
    };
    async function submit() {
        // let re = new RegExp("^[A-PR-WYa-pr-wy][1-9]\\d\\s?\\d{4}[1-9]$");
        let div = document.getElementById('passno');
        if (div.value.length >= 2 && div.value.length < 15)
            if (file != null) {
                var formData = new FormData();
                formData.append('passport_no', document.getElementById('passno').value);
                formData.append('passport_photho', file);
                await axios({
                    method: "post",
                    url: `${process.env.REACT_APP_API_URL1}/consultant/Passport_module/`,
                    data: formData,
                    headers: {
                        "Content-Type": "multipart/form-data",
                        'Authorization': `JWT ${localStorage.getItem('access')}`,
                        'Accept': 'application/json'
                    },
                }).then(async response => {
                    console.log(response)
                    setBol(false)
                    await axios.get(`${process.env.REACT_APP_API_URL1}/consultant/Passport_module/`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `JWT ${localStorage.getItem('access')}`,
                            'Accept': 'application/json'
                        }
                    })
                        .then(response => {
                            setData(response.data)
                            response.data.passport_number === "" ? setBol(true) : console.log('allset')
                        }).catch(err => {
                            console.log(err)
                        })
                }).catch(err => {
                    console.log(err)
                    console.log(formData)
                })
            }
            else {
                setError('Please select a file');
            }
        // else setError('Enter a valid Passport Value')
        else setError('Please Enter a valid Passport Number');
        setTimeout(() => {
            setError('')
        }, 2000);
    }
    const [error, setError] = useState('');
    return (
        <div className='passtop'>
            <div className='passport'>
                <div><span>{data.passport_number!=''||bol?'Passport number :':'Passport details not updated'} </span>{bol ? <input id='passno' type='text' /> : <>{data.passport_number!=''?data.passport_number:''}</>}<br /></div>
                <div><span>{data.passport_number!=''||bol?'Passport file :':''} </span>{!bol ? <span style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }} onClick={() => window.open(process.env.REACT_APP_API_URL1 + data.passport_file, "Passport View", `popup,height=700,width=1000`)} >{data.passport_number!=''||bol?'View':''}</span> : <>
                
                <FileUploader types={fileTypes} children={
                        <div className='drop-zone'>
                            <p>Click to browse or <br />drag and drop your files{!file ? <><br />{fileTypes.join(', ')}</> : <></>}<br />{file ? `${file.name}` : ""}</p>
                        </div>
                    } handleChange={handleChange} name="file" />
                </>}</div>
            </div>
            <div className='all'><br />
                <div style={{ color: 'red' }}>{error}</div><br />
                {bol ? <><button onClick={() => setBol(false)} className='passbut'>Back</button>&emsp;&emsp;</> : <></>}
                {bol ? <><button onClick={() => submit()}>Submit</button></> : <><button onClick={() => setBol(true)}>{data.passport_number!=''?'Edit':'Fill the Details'}</button></>}
            </div>
        </div>
    )
}
